module.exports = __webpack_public_path__ + "img/img_join.670d08d8.jpg";